import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm, reset } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { CommonButton } from '../../../../components/buttons';
// import RaisedButton from 'material-ui/RaisedButton';
import { isInteger, renderAutoCompleteSingleSelect,
  renderTextField,
} from '../../../../components/reduxFields';
import { getPatientPayerServiceCodes } from './actions/soapActions';
import { Scrollbars } from 'react-custom-scrollbars';
const validate = (values) => {
  const errors = {};

  if (!values.CPTID) {
    errors.CPTID = 'Please select CPT code.';
  }

  if (!values.Quantity) {
    errors.Quantity = 'Please enter unit.';
  }
  return errors;
};

// props.master_CPT ? props.master_CPT :

class CPTModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      //masterCPT: [],
      isValidServiceCode: true,
      dropdownProcedureCodes: [],
      dropdownProcedureCodeModifiers: [],
      dropdownFilteredModifiers: [],
      attachedModifiers:'',
      remainingUnits: 1000,
      isUnitRemaining: true,
    };
    this.filter = {
      searchText: '',
    };
    // this.handleSearchCPTcodes = this.handleSearchCPTcodes.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  loadCPTs() { // description: this.filter.searchText,
    let searchObj = {
      patientId: this.props.patientId,
      payerPreference: 'primary',
      dateTime: this.props.dateOfService,
      payerId: 0,
      patientInsuranceId: this.props.patientInsuranceId || null,
      appointmentId: this.props.apptid || 0,
    };
    this.props.getPatientPayerServiceCodes(searchObj);
  }

  componentWillMount() {
    // this.props.getMasterData();
    this.loadCPTs();
  }

  filterByReference = (arr1, arr2) => {
    let res = [];
    res = arr1.filter(el => {
       return !arr2.find(element => {
          return element.ServiceCodeId === el.serviceCodeId;
       });
    });
    return res;
 }

  componentWillReceiveProps(nextProps) {
    if (nextProps.payerCptCodes && this.props.payerCptCodes !== nextProps.payerCptCodes) {
      let payerData = nextProps.payerCptCodes;
      let payerCptCodes = [];
      let payerCptCodeModifiers = [];
      if (payerData && payerData.ServiceCodes) {
        if(this.props.isEditServiceCode){
          payerCptCodes = (payerData.ServiceCodes || []).map((cpt, index) => {           
            return {
              'id': cpt.serviceCodeId + '_' + cpt.authProcedureCPTLinkId,
              //'id': cpt.serviceCodeId,
              'value': cpt.serviceCode,
              //'authProcedureCPTLinkId': cpt.authProcedureCPTLinkId,
              ...cpt,
            };           
          });
        }
        else {
          var filterServiceCodes = this.filterByReference(payerData.ServiceCodes, this.props.cptArray);
          payerCptCodes = (filterServiceCodes || []).map((cpt, index) => {
              return {
                'id': this.props.isEditServiceCode ? cpt.serviceCodeId : cpt.serviceCodeId + '_' + cpt.authProcedureCPTLinkId,
                //'id': cpt.serviceCodeId,
                'value': cpt.serviceCode,
                //'authProcedureCPTLinkId': cpt.authProcedureCPTLinkId,
                ...cpt,
              };
          });
        }
      }
      if (payerData && payerData.ServiceCodeModifiers) {
        payerCptCodeModifiers = (payerData.ServiceCodeModifiers || []).map((cptModifier, index) => {
          return {
            'id': cptModifier.payerModifierId,
            'value': cptModifier.modifier,
            ...cptModifier,
          };
        });
      }
      //console.log('payerCptCodes...........',payerCptCodes)
      //let cptCodes = payerCptCodes.filter((data) => data.isRequiredAuthorization === true);
      this.setState({
        remainingUnits: nextProps.remainingUnits,
        dropdownProcedureCodes: payerCptCodes,
        dropdownProcedureCodeModifiers: payerCptCodeModifiers,
      });
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {

    if (input.name === 'CPTID') {
      //let arr =  selectedRecord.value.split('_'); 
      //let serviceCodeId =  arr.length > 0 ? selectedRecord.value.split('_')[0] : selectedRecord.value; 
      //let authProcedureCPTLinkId =  arr.length > 1 ? selectedRecord.value.split('_')[1] : 0; 
      //console.log('serviceCodeId...........',serviceCodeId)
      //console.log('selectedRecord.value...........',selectedRecord.value)
      let cptData = this.state.dropdownProcedureCodes.find((obj) => obj.id.toString() === selectedRecord.value.toString());
      //console.log('cptData...........',cptData)
    
      //selectedRecord.value = serviceCodeId; 
      
      if (cptData) {        
        let isValid = cptData.isRequiredAuthorization ? cptData.isValid : true;
        let remainingUnits = cptData.remainingUnits;
        let dropdownFilteredModifiers = (this.state.dropdownProcedureCodeModifiers || []).filter((obj) => {
          return obj.payerServiceCodeId === (cptData && cptData.payerServiceCodeId);
        });

        this.setState({ isValidServiceCode: isValid, remainingUnits: remainingUnits, dropdownFilteredModifiers: dropdownFilteredModifiers });        
      }
    }
    else
    {
        let attachedModifiers = this.state.attachedModifiers;
        if(attachedModifiers === '')
        {
            attachedModifiers = selectedRecord.label; 
        }
        else
        {
          attachedModifiers = attachedModifiers + ', ' +  selectedRecord.label;
        }
        this.setState({ attachedModifiers: attachedModifiers});        
    }
    //console.log('selectedRecord...........',selectedRecord);
    input.onChange(selectedRecord.value);  
  }
  // handleSearchCPTcodes(value, dataSource) {
  //   // console.log(value);
  //   if (value.trim().length >= 3) {
  //     this.filter.searchText = value;
  //     this.loadCPTs();
  //   } else if (value === '') {
  //     this.filter.searchText = '';
  //     this.loadCPTs();
  //   }
  // }
  onAddSubmitHandler = (formProps) => {
  //  console.log('formProps...........',formProps)
  //  console.log('this.state.dropdownProcedureCodes...........',this.state.dropdownProcedureCodes)
   //console.log('formProps.Quantity...........',formProps.Quantity)
    var quantity = formProps.Quantity;
    // if(this.props.isEditServiceCode)
    // {
    //     if(this.props.previouslyAddedUnits > formProps.Quantity)
    //     {
    //       quantity = this.props.previouslyAddedUnits - formProps.Quantity;
    //     }
    //     else if(formProps.Quantity > this.props.previouslyAddedUnits) 
    //     {
    //       quantity = formProps.Quantity - this.props.previouslyAddedUnits;
    //     }
    //     else if(formProps.Quantity === this.props.previouslyAddedUnits) 
    //     {
    //       quantity = 0;
    //     }
    // }

    if((this.state.remainingUnits - quantity) < 0)
    {      
      this.setState({ isUnitRemaining: false});        
    }
    else
    {
      this.setState({ isUnitRemaining: true},()=>{
        if (this.state.isValidServiceCode) {
          let cptData = this.state.dropdownProcedureCodes.find((obj) => obj.id === formProps.CPTID);
          if (cptData) {
            formProps.AuthProcedureCPTLinkId = cptData.authProcedureCPTLinkId;
            formProps.AuthorizationNumber = cptData.authorizationNumber;
            formProps.attachedModifiers = this.state.attachedModifiers ? this.state.attachedModifiers : this.props.attachedModifiers;
            formProps.ServiceCodeId = cptData.serviceCodeId;            
            formProps.RemainingUnits = cptData.remainingUnits;
          }
          this.props.handleAddCPT(formProps,this.props.isEditServiceCode);
          this.handleClose();
        }
      });
    }
  }
  onAddMoreSubmitHandler = (formProps) => {
    var quantity = formProps.Quantity;
    // if(this.props.isEditServiceCode)
    // {
    //     if(this.props.previouslyAddedUnits > formProps.Quantity)
    //     {
    //       quantity = this.props.previouslyAddedUnits - formProps.Quantity;
    //     }
    //     else if(formProps.Quantity > this.props.previouslyAddedUnits) 
    //     {
    //       quantity = formProps.Quantity - this.props.previouslyAddedUnits;
    //     }
    //     else if(formProps.Quantity === this.props.previouslyAddedUnits) 
    //     {
    //       quantity = 0;
    //     }
    // }

    if((this.state.remainingUnits - quantity) < 0)
    {                
      this.setState({ isUnitRemaining: false});        
    }
    else
    {
      this.setState({ isUnitRemaining: true},()=>{
        if (this.state.isValidServiceCode) {
          let cptData = this.state.dropdownProcedureCodes.find((obj) => obj.id === formProps.CPTID);
          if (cptData) {
            formProps.AuthProcedureCPTLinkId = cptData.authProcedureCPTLinkId;
            formProps.AuthorizationNumber = cptData.authorizationNumber;
            formProps.attachedModifiers = this.state.attachedModifiers;
            formProps.ServiceCodeId = cptData.serviceCodeId;
          }
          this.props.handleAddCPT(formProps,this.props.isEditServiceCode);
          this.props.dispatch(reset('Form_SoapCPTModal'));
          this.filter.searchText = '';
          let cptCodes = this.state.dropdownProcedureCodes;
          let indexCpt = this.state.dropdownProcedureCodes.indexOf(cptData);
          cptCodes.splice(indexCpt, 1);
          this.setState({ dropdownProcedureCodes: cptCodes });
          // this.loadCPTs();
        }
      });
    }
  }

  handleQuantityChange(event) {
    var quantity = event.target.value;
    
    // console.log('this.state.remainingUnits.............',this.state.remainingUnits)
    // console.log('event.target.value.............',event.target.value)
    // console.log('this.props.previouslyAddedUnits.............',this.props.previouslyAddedUnits)
    
    // if(this.props.isEditServiceCode)
    // {
    //     if(this.props.previouslyAddedUnits > event.target.value)
    //     {
    //       quantity = this.props.previouslyAddedUnits - event.target.value;
    //     }
    //     else if(event.target.value > this.props.previouslyAddedUnits) 
    //     {
    //       quantity = event.target.value - this.props.previouslyAddedUnits;
    //     }
    //     else if(event.target.value === this.props.previouslyAddedUnits) 
    //     {
    //       quantity = 0;
    //     }
    // }
    //console.log('quantity.............',quantity)

    if((this.state.remainingUnits - quantity) < 0)
    {            
      this.setState({ isUnitRemaining: false});        
    }
    else
    {
      this.setState({ isUnitRemaining: true});
    }
  }

  render() {
    const { handleSubmit } = this.props;
    let btns = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={this.handleClose}/>,
      <CommonButton type="submit" label={this.props.isEditServiceCode ? "Update": "Add"} className="mr-15" primary={true} onTouchTap={handleSubmit(this.onAddSubmitHandler)}/>,
      // !this.props.isEditServiceCode && <CommonButton type="submit" primary={true} label= "Add More" onTouchTap={handleSubmit(this.onAddMoreSubmitHandler)}/>,
    ];

    const actions = [ <div className="sm-btn-scroll"><Scrollbars>{btns} </Scrollbars></div>]
    return (
      <div>
        {this.state.open ?
          <Dialog className="custom_modal"
            title={this.props.isEditServiceCode ? 'Edit Service Codes' : 'Add Service Codes'}
            modal={false}
            open={this.state.open}
            actions={actions}
            // onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
          >
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 require mt-40">
                      <Field
                        name="CPTID"
                        label="Search Service Code"
                        options={this.state.dropdownProcedureCodes}
                        handleNewRequest={this.handleNewRequest}
                        // handleUpdateInput={this.handleSearchCPTcodes}
                        disabled={this.props.isEditServiceCode ? true : false}
                        customError={!this.state.isValidServiceCode ? 'Selected service code is not authorized.' : ''}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 require">
                      <Field
                        name="Quantity"
                        type="text"
                        maxLength="3"
                        label="Unit"
                        component={renderTextField}
                        onChange={this.handleQuantityChange}
                        normalize={isInteger}
                        customError={!this.state.isUnitRemaining ? 'Authorized units are not remaining' : ''}
                      />
                    </div>
                    <div className="col-sm-12">
                      <div className="row">
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                            name="Modifier1"
                            label="Modifier 1"
                            handleNewRequest={this.handleNewRequest}
                            //disabled={this.props.isEditServiceCode ? true : false}
                            options={this.props.dropdownFilteredModifiers ? this.props.dropdownFilteredModifiers : this.state.dropdownFilteredModifiers}
                            component={renderAutoCompleteSingleSelect}
                          />
                         
                        </div>
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                              name="Modifier2"
                              label="Modifier 2"
                              handleNewRequest={this.handleNewRequest}
                              //disabled={this.props.Modifier1 && this.props.isEditServiceCode ? false : true}                              
                              options={this.state.dropdownFilteredModifiers}
                              component={renderAutoCompleteSingleSelect}
                            />
                         
                        </div>
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                            name="Modifier3"
                            label="Modifier 3"
                            handleNewRequest={this.handleNewRequest}
                           // disabled={this.props.Modifier2 && this.props.isEditServiceCode ? false : true}
                            options={this.state.dropdownFilteredModifiers}
                            component={renderAutoCompleteSingleSelect}
                          />
                        </div>
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                            name="Modifier4"
                            label="Modifier 4"
                            handleNewRequest={this.handleNewRequest}
                           // disabled={this.props.Modifier3 && this.props.isEditServiceCode ? false : true}
                            options={this.state.dropdownFilteredModifiers}
                            component={renderAutoCompleteSingleSelect}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

const selector = formValueSelector('Form_SoapCPTModal');

function mapStateToProps(state, ownProps) {
  let initialData = {}
  let dropdownFilteredModifiers = null;
  let isEditServiceCode = false;
  let apptid = null;
  let remainingUnits = 1000;  
  //let previouslyAddedUnits = 0;
  let attachedModifiers = '';
  let payerCptCodeModifiers = [];
  if(ownProps && ownProps.apptid)  
    apptid= ownProps.apptid;
  
  if(ownProps && ownProps.isEditServiceCode)
  {
    isEditServiceCode = ownProps.isEditServiceCode;
    // console.log('ownProps.CPTSingleData[0].......',ownProps.CPTSingleData[0])
    initialData['CPTID'] = ownProps.CPTSingleData[0].ServiceCodeId + "_" +  ownProps.CPTSingleData[0].AuthProcedureCPTLinkId;
    initialData['Quantity'] = ownProps.CPTSingleData[0].Quantity;
    initialData['Modifier1'] = ownProps.CPTSingleData[0].Modifier1;
    initialData['Modifier2'] = ownProps.CPTSingleData[0].Modifier2;
    initialData['Modifier3'] = ownProps.CPTSingleData[0].Modifier3;
    initialData['Modifier4'] = ownProps.CPTSingleData[0].Modifier4;
    
    let payerData = state.soap.searched_CPTs && state.soap.searched_CPTs.data ? state.soap.searched_CPTs.data:[];
    
    if (payerData && payerData.ServiceCodeModifiers) {
      payerCptCodeModifiers = (payerData.ServiceCodeModifiers || []).map((cptModifier, index) => {
        return {
          'id': cptModifier.payerModifierId,
          'value': cptModifier.modifier,
          ...cptModifier,
        };
      });
    }  
    // dropdownFilteredModifiers = (payerCptCodeModifiers || []).filter((obj) => {
    //   return obj.id === (ownProps.CPTSingleData[0].Modifier1 || ownProps.CPTSingleData[0].Modifier2 || ownProps.CPTSingleData[0].Modifier3 || ownProps.CPTSingleData[0].Modifier4);
    // });

    // dropdownFilteredModifiers = (payerCptCodeModifiers || []).filter((obj) => {
    //   return obj.id === (ownProps.CPTSingleData[0].Modifier1 || ownProps.CPTSingleData[0].Modifier2 || ownProps.CPTSingleData[0].Modifier3 || ownProps.CPTSingleData[0].Modifier4);
    // });
  
    //selectedRecord.value = serviceCodeId; 
    
    if (state.soap.searched_CPTs && state.soap.searched_CPTs.data) {   
      let cptData = state.soap.searched_CPTs.data.ServiceCodes.find((obj) => obj.serviceCodeId.toString() ===  ownProps.CPTSingleData[0].ServiceCodeId.toString() );
      
      dropdownFilteredModifiers = (payerCptCodeModifiers || []).filter((obj) => {
        return obj.payerServiceCodeId === (cptData && cptData.payerServiceCodeId);
      });
            
      let cptDataForRemainingUnits = state.soap.searched_CPTs.data.ServiceCodes.find((obj) => obj.authProcedureCPTLinkId ===  ownProps.CPTSingleData[0].AuthProcedureCPTLinkId);
      
      remainingUnits = cptDataForRemainingUnits && cptDataForRemainingUnits.remainingUnits ? cptDataForRemainingUnits.remainingUnits : ownProps.CPTSingleData[0].RemainingUnits;
      
      // dropdownFilteredModifiers = (payerCptCodeModifiers || []).filter((obj) => {
      //   return obj.payerServiceCodeId === (cptData && cptData.payerServiceCodeId);
      // });
            
    }

    if(initialData['Modifier1'] !== undefined || initialData['Modifier2'] !== undefined || initialData['Modifier3'] !== undefined || initialData['Modifier4'] !== undefined)
    {
      (dropdownFilteredModifiers || []).forEach((obj, index) => {      
        if(attachedModifiers === '')
        {
            attachedModifiers = obj.modifier; 
        }
        else
        {
          attachedModifiers = obj.modifier + ', ' +  obj.modifier;
        }      
      });
     }

    // console.log('initialData.......',initialData)
    //remainingUnits = ownProps.CPTSingleData[0].RemainingUnits;
    remainingUnits = remainingUnits + ownProps.CPTSingleData[0].Quantity;
    // console.log('dropdownFilteredModifiers.......',dropdownFilteredModifiers)
    //  console.log('ownProps.CPTSingleData.......',ownProps.CPTSingleData[0])
    //console.log('remainingUnits.......',remainingUnits)
  }

  return {
    Modifier1: selector(state, 'Modifier1'),
    Modifier2: selector(state, 'Modifier2'),
    Modifier3: selector(state, 'Modifier3'),
    Modifier4: selector(state, 'Modifier4'),
    loading: state.soap.loading,
    payerCptCodes: state.soap.searched_CPTs && state.soap.searched_CPTs.data ? state.soap.searched_CPTs.data : [],
    initialValues: initialData,
    dropdownFilteredModifiers: dropdownFilteredModifiers,
    isEditServiceCode: isEditServiceCode,
    remainingUnits: remainingUnits,
    apptid: apptid,
    attachedModifiers: attachedModifiers,
    cptArray: ownProps.cptArray || [],
    //previouslyAddedUnits: previouslyAddedUnits,
  };
}


CPTModal = reduxForm({
  form: 'Form_SoapCPTModal',
  validate,
  enableReinitialize: true,
})(CPTModal);

export default connect(mapStateToProps, { getPatientPayerServiceCodes })(CPTModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/soap/soap_CPTModal.js